module.exports = __webpack_public_path__ + "img/mysore-raspberry-350x184.ed763413.jpg";